export function RewardsRecognitionSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/rewards-recognition.svg'"></ng-include>`
    }
}
